import React, { useState, useEffect } from "react";
import { getMoleculeSVG } from "../../../utils/Api";

type MoleculeProps = {
  object: {
    x: number,
    y: number,
    width: number,
    height: number,
    transcription: string,
  },
};

const Molecule: React.FC<MoleculeProps> = ({ object }) => {
  const [hovered, setHovered] = useState < boolean > false;
  const [imageUrl, setImageUrl] = useState < string > "";
  const [loading, setLoading] = useState < boolean > false;

  useEffect(() => {
    if (object.transcription && hovered) {
      setLoading(true);
      const fetchImage = async () => {
        try {
          const response = await getMoleculeSVG(object.transcription);
          const objectBlob = new Blob([response.data], {
            type: "image/svg+xml",
          });
          const objectURL = URL.createObjectURL(objectBlob);
          setImageUrl(objectURL);
        } catch (error) {
          console.error("Error fetching molecule image:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchImage();

      return () => {
        if (imageUrl) {
          URL.revokeObjectURL(imageUrl);
        }
      };
    }
  }, [object.transcription, hovered, imageUrl]);

  return (
    <div
      className="absolute box-border border border-blue-500 bg-blue-500/10 border-1 pointer-events-auto z-10"
      style={{
        left: `${object.x}px`,
        top: `${object.y}px`,
        width: `${object.width}px`,
        height: `${object.height}px`,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {hovered && (
        <div
          className="absolute bottom-full left-1/2 -translate-x-1/2 mb-px z-20
                               bg-white border border-1 border-black rounded-xs p-0.5 shadow-md
                               flex items-center justify-center w-full"
        >
          {loading && <p>Loading image...</p>}
          {imageUrl && <img src={imageUrl} alt="Molecule" />}
        </div>
      )}
    </div>
  );
};

export default Molecule;
